import { ContentFader } from '@repo/shared/components';
import { UspItem } from '@/components/usp-item';
import { USP_HIGHLIGHT_TITLES } from '@/constants';

export const USPHighlight = () => {
	const contentList = USP_HIGHLIGHT_TITLES.map((title) => (
		<UspItem key={title} title={title} />
	));
	return (
		<div className="flex items-center justify-center bg-gradient-to-r from-success-solid to-success-solid-over text-success-solid">
			<ContentFader
				contentList={contentList}
				className="py-5px mx-20 w-full h-7"
			/>
		</div>
	);
};
